import { motion as m, useAnimation, useInView } from "framer-motion";
import React, { useEffect, useRef } from "react";

const PageFrames = ({ children, id = "" }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });
  const mainControls = useAnimation();

  useEffect(() => {
    if (isInView) {
      mainControls.start("visible");
    }
  }, [isInView]);
  return (
    <m.div
      id={id}
      ref={ref}
      className="flex flex-col w-full h-full items-center my-10 gap-4 lg:gap-8"
      variants={{
        hidden: { opacity: 0, y: -20 },
        visible: { opacity: 1, y: 0 },
      }}
      initial="hidden"
      animate={mainControls}
      transition={{ duration: 1 }}
    >
      {children}
    </m.div>
  );
};

export default PageFrames;
